import { CloseIcon } from "@chakra-ui/icons";
import {
	Box,
	Button,
	HStack,
	IconButton,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverContent,
	PopoverTrigger,
	Text
} from "@chakra-ui/react";
import { FunctionComponent, useState } from "react";
import { MdFilterList } from "react-icons/md";

interface OptionItem {
	value: string;
	label: string;
}

interface InlineFilterPopoverProps {
	shownText: string;
	isFiltered: boolean;
	onClear: () => void;
	roleValue: string;
	onRoleChange: (value: string) => void;
	typeLabel: string;
	typeValue: string;
	onTypeChange: (value: string) => void;
	typeOptions: OptionItem[];
	onApply: () => void | Promise<void>;
}

const InlineFilterPopover: FunctionComponent<InlineFilterPopoverProps> = ({
	shownText,
	isFiltered,
	onClear,
	roleValue,
	onRoleChange,
	typeLabel,
	typeValue,
	onTypeChange,
	typeOptions,
	onApply
}) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<HStack width="100%" gap="2" py="5px" pr="1">
			<Popover isOpen={isOpen} onClose={() => setIsOpen(false)} placement="bottom-start">
				<PopoverTrigger>
					<Button
						size="xs"
						pl={3}
						minW="unset"
						variant="solid"
						colorScheme="blackAlpha"
						backgroundColor="gray.500"
						onClick={() => setIsOpen(!isOpen)}>
						{shownText}
						{!isFiltered && (
							<>
								&nbsp;&nbsp;
								<MdFilterList fontSize="18px" />
							</>
						)}
					</Button>
				</PopoverTrigger>
				<PopoverContent width="340px">
					<PopoverArrow />
					<PopoverBody>
						<HStack mb={2}>
							<Text flex="1" textAlign="right" mt="7px">
								Role
							</Text>
							<select
								style={{ width: "200px", fontSize: "1rem", border: "1px solid #CBD5E0", borderRadius: 4, padding: 6 }}
								value={roleValue}
								onChange={(e) => onRoleChange(e.target.value !== "null" ? e.target.value : "")}>
								<option value="null">Any</option>
								{/* Roles are supplied by parent via onRoleChange string values */}
								<option value="Admin">Admin</option>
								<option value="ClaimsAdmin">ClaimsAdmin</option>
								<option value="ClaimsAnalyst">ClaimsAnalyst</option>
								<option value="ClaimsManager">ClaimsManager</option>
								<option value="ClaimsViewOnly">ClaimsViewOnly</option>
								<option value="ClaimsNetworkManager">ClaimsNetworkManager</option>
								<option value="Developer">Developer</option>
								<option value="Member">Member</option>
								<option value="MembersServices">MembersServices</option>
								<option value="Provider">Provider</option>
								<option value="ProvidersServices">ProvidersServices</option>
								<option value="Payments">Payments</option>
							</select>
						</HStack>
						<HStack>
							<Text flex="1" textAlign="right" mt="7px">
								{typeLabel}
							</Text>
							<select
								style={{ width: "200px", fontSize: "1rem", border: "1px solid #CBD5E0", borderRadius: 4, padding: 6 }}
								value={typeValue}
								onChange={(e) => onTypeChange(e.target.value !== "null" ? e.target.value : "")}>
								<option value="null">Any</option>
								{typeOptions.map((opt) => (
									<option key={opt.value} value={opt.value}>
										{opt.label}
									</option>
								))}
							</select>
						</HStack>
						<HStack mt={5} mb={2} gap="5" justifyContent="center">
							<Button
								width="100px"
								size="sm"
								colorScheme="blackAlpha"
								backgroundColor="gray.500"
								onClick={() => {
									onClear();
									setIsOpen(false);
								}}>
								Clear
							</Button>
							<Button
								width="100px"
								size="sm"
								colorScheme="orange"
								onClick={async () => {
									await onApply();
									setIsOpen(false);
								}}>
								Filter
							</Button>
						</HStack>
					</PopoverBody>
				</PopoverContent>
			</Popover>
			{isFiltered && (
				<IconButton
					size="xs"
					p="5px"
					h="20px"
					aria-label="clear"
					borderRadius="10px"
					minWidth="20px"
					icon={<CloseIcon fontSize="10px" />}
					onClick={onClear}
				/>
			)}
		</HStack>
	);
};

export default InlineFilterPopover;
